import React, { useState, useEffect } from 'react';
import {
  Box,
  Container,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Button
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AdminLayout from '../Admin_Layout/AdminLayout';
import { useNavigate, useLocation } from 'react-router-dom';

const BlogsTable = ({ role = 'admin' }) => {
  const [blogData, setBlogData] = useState([]);
  const navigate = useNavigate();
  const [message, setMessage] = useState('No Blogs');
  const location = useLocation();
  useEffect(() => {
    const fetchBlogs = async () => {
      let userId = localStorage.getItem('userId');
      console.log("Current userId:", userId);

      if (role === 'user') {
        if (!userId) {
          console.warn("UserId missing, redirecting to login...");
          return navigate('/login');
        }
      }

      let url = role === 'admin' ? process.env.REACT_APP_API_URL + '/api/blogs' : process.env.REACT_APP_API_URL + '/api/blogs/user/' + userId;
      console.log("BlogsTable loading... role:", role, "userId:", userId);

      try {
        const response = await fetch(url);
        console.log('response from server: ' + response.message)
        if (response.message) setMessage(response.message)
        if (!response.ok) throw new Error('Failed to fetch blogs');
        const data = await response.json();
        const sortedData = data.sort((a, b) => a.index - b.index); // ← oldest first (ascending)
        setBlogData(sortedData);
      } catch (error) {
        console.error('Error fetching blogs:', error);
      }
    };

    fetchBlogs();
  }, [location.state, navigate, role]);

  const handleEdit = (blog) => {
    console.log('edit button clicked...');
    role === 'admin' ? navigate('/admin-dashboard/manage-blogs/update-blog/specific', { state: { update: true, formData: blog } }) : navigate('/user-dashboard/manage-blogs/update-blog/specific', { state: { update: true, formData: blog } });
    ;
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this blog?")) {
      try {
        const token = localStorage.getItem("token"); // Get token from localStorage

        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/blogs/${id}`, {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`, // Attach token for authentication
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          throw new Error("Failed to delete the blog.");
        }

        // Remove the deleted blog from state
        setBlogData((prevData) => prevData.filter((item) => item._id !== id));

        alert("Blog deleted successfully!");
      } catch (error) {
        console.error("Error deleting blog:", error);
        alert("Failed to delete the blog. Please try again.");
      }
    }
  };


  const handleComments = (id) => {
    navigate('/admin-dashboard/comments', { state: { articleId: id } })
  }

  return (
    <AdminLayout role={role}>
      {blogData.length > 0 ?
        <Box sx={{ p: 4 }}>
          <Container maxWidth="lg">
            <Paper elevation={3} sx={{ p: 3, borderRadius: 2 }}>
              <Typography variant="h4" gutterBottom sx={{ mt: 5 }}>
                Blogs
              </Typography>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell><strong>Index</strong></TableCell>
                      <TableCell><strong>Title</strong></TableCell>
                      <TableCell><strong>Author</strong></TableCell>
                      <TableCell><strong>Author Image</strong></TableCell>
                      <TableCell><strong>Image</strong></TableCell>
                      <TableCell><strong>Actions</strong></TableCell>
                      <TableCell><strong>Status</strong></TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {blogData.map((blog, index) => (
                      <TableRow key={index}>
                        <TableCell>{blog.index}</TableCell>
                        <TableCell>{blog.title}</TableCell>
                        <TableCell>{blog.author}</TableCell>
                        <TableCell>
                          {blog.authorImage ? (
                            <img
                              src={blog.authorImage}
                              alt={blog.authorImage}
                              style={{ width: 100, height: 60, objectFit: 'cover', borderRadius: '4px' }}
                            />
                          ) : (
                            'No Image'
                          )}
                        </TableCell>
                        <TableCell>
                          {blog.imageURL ? (
                            <img
                              src={blog.imageURL}
                              alt={blog.imageURL}
                              style={{ width: 100, height: 60, objectFit: 'cover', borderRadius: '4px' }}
                            />
                          ) : (
                            'No Image'
                          )}
                        </TableCell>
                        {(role === 'admin' || (role === 'user' && blog.status !== 'published')) ? <TableCell>
                          <IconButton
                            color="primary"
                            onClick={() => handleEdit(blog)}
                          >
                            <EditIcon />
                          </IconButton>
                          <IconButton
                            color="primary"
                            onClick={() => handleDelete(blog._id)}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </TableCell> : <TableCell></TableCell>}
                        <TableCell>{blog.status}</TableCell>

                        {role === 'admin' && <TableCell>
                          <Button onClick={() => { handleComments(blog._id) }}>Review Comments</Button>
                        </TableCell>}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          </Container>
        </Box> :
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Typography variant='h2' gutterBottom sx={{ mt: 20 }}>{message}</Typography>
        </Box>}
    </AdminLayout>
  );
};

export default BlogsTable;
